module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.33",
      url: __webpack_public_path__ + "svg-sprite-58d03b3f1466f1d475a0d37264fe8fc2.svg#google-play",
      toString: function () {
        return this.url;
      }
    }